






























































































import {API} from '@/services/api/api';
import {Vue, Component} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {
    ...mapActions(['setCurrentTab', 'showSuccessToast', 'showErrorToast']),
  },
  computed: {...mapGetters(['roleList'])},
})
export default class CreateClass extends Vue {
  className = '';
  classStatus = false;
  select = '';
  classNameValidationMsg = '';
  classStatusValidationMsg = '';
  selectValidationMsg = '';

  commonValidationMsg = 'This field is required';

  showSuccessToast: any;
  showErrorToast: any;
  setCurrentTab: any;

  btnLoader = false;
  selectedRoleList: any = [];
  roleList: any;

  //validation class name
  validateClassName() {
    if (this.className === '' || this.className.length < 1) {
      this.classNameValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.classNameValidationMsg = '';
      return true;
    }
  }

  //validation class Status
  validateClassStatus() {
    if (!this.classStatus && this.classStatus === false) {
      this.classStatusValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.classStatusValidationMsg = '';
      return true;
    }
  }

  //validation role
  validateRole() {
    if (this.selectedRoleList.length < 1) {
      this.selectValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.selectValidationMsg = '';
      return true;
    }
  }

  showData(event, option) {
    if (event.target.checked && event.target.checked === true) {
      this.selectedRoleList.push({
        groupId: option.groupId,
      });
      this.selectValidationMsg = '';
    } else {
      this.selectedRoleList.pop();
    }
  }

  //chaeck all validation before API call
  validateAll() {
    return this.validateClassName() && this.validateRole();
  }
  async _handleCreate() {
    if (!this.validateAll()) return;

    try {
      this.btnLoader = true;

      const formInput = {
        className: this.className,
        isActive: this.classStatus,
        surveyorGroups: this.selectedRoleList,
      };
      const response = await API.createClass(formInput);
      if (response.data) {
        this.showSuccessToast({msg: response.message});
        this.$router.go(-1);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.btnLoader = false;
    }
  }

  //Go back
  goToList() {
    this.$router.go(-1);
  }
}
